<template>
  <div class="py-4">
    <hr>
    <div v-if="farbe.length >= 1" class="py-2">
        <h1 class="text-gray-800 font-semibold text-xl">Farbe</h1>
        <div class="flex">
            <div v-for="(f, index) in farbe" :key="index.id" class="px-1">
                <router-link v-if="f.selected !== true" :to="{ name: 'product', params: { id: f.variant_id } }">
                    <div class="farbe my-1" :data-tooltip="f.farbe_title">
                        <img :class="f.selected == true ? 'border-2 border-teal-400' : ''" class="farbe w-10 text-center item border-2 hover:border-teal-400 rounded-full" :src="f.farbe" alt="">
                    </div>
                </router-link>
                <div v-else class="farbe my-1" :data-tooltip="f.farbe_title">
                    <img :class="f.selected == true ? 'border-2 border-teal-400' : ''" class="farbe w-10 text-center item border-2 hover:border-teal-400 rounded-full" :src="f.farbe" alt="">
                </div>
            </div>
        </div>
    </div>
    <div v-if="dimensions.length >= 1" class="py-2">
        <h1 class="text-gray-800 font-semibold text-xl">Verfügbare Kombinationen</h1>
        <div class="flex">
            <div v-for="(d, index) in dimensions" :key="index.id">
                <router-link v-if="d.selected !== true" :to="{ name: 'product', params: { id: d.variant_id } }">
                    <div class=" my-1">
                        <button class="border-2 rounded hover:border-teal-400 text-gray-900 px-4 py-1 hover:text-teal-400 mr-1">{{ d.dimensions }} cm</button>
                    </div>
                </router-link>
                <div v-else class=" my-1">
                    <button :class="d.selected == true ? 'border-2 border-teal-400' : ''"  class="border-2 rounded hover:border-teal-400 text-gray-900 px-4 py-1 hover:text-teal-400 mr-1">{{ d.dimensions }} cm</button>
                </div>
            </div>
        </div>
    </div>
    <hr>
      <div v-if="variants.length >= 1" class="py-2">
        <h1 class="text-gray-800 font-semibold text-xl">Weitere Ausführungen</h1>
        <div v-for="(v, index) in variants" :key="index.id">
            <router-link :to="{ name: 'product', params: { id: v.id } }">
                <div class="farbe my-1" :data-tooltip="v.name">
                    <img class="w-24 text-center border-2 hover:border-teal-400 rounded" :src="v.product_image" alt="Product Image">
                </div>
            </router-link>
        </div>
      </div>
      <hr>
  </div>
</template>

<script>

export default {
    props: {
        farbe: Array,
        dimensions: Array,
        variants: Array
    },
    data() {
        return {

        }
    }
}
</script>

<style scoped>
    .farbe {
        position: relative;
    }

    .farbe::before,
    .farbe::after {
        --scale: 0;

        position: absolute;
        top: -.25rem;
        left: 50%;
        transform: translateX(-50%) translateY(-100%) scale(var(--scale));
        transition: 150ms transform;
        transform-origin: bottom center;
    }

    .farbe::before {
        content: attr(data-tooltip);
        color: #4fd1c5;
        font-weight: 500;
        padding: .3rem;
        width: auto;
        background: white;
        box-shadow: 0.3em 0.3em 1em rgba(0,0,0,0.3);
        border-radius: .3rem;
        text-align: center;
        z-index: 1;
    }

    .farbe:hover::before,
    .farbe:hover::after {
        --scale: 1;
    }
</style>